import { render } from "./AvatarImage.vue?vue&type=template&id=04b0e017&scoped=true"
import script from "./AvatarImage.vue?vue&type=script&lang=js"
export * from "./AvatarImage.vue?vue&type=script&lang=js"

import "./AvatarImage.vue?vue&type=style&index=0&id=04b0e017&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b0e017"]])

export default __exports__